import { Form, Select } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import React from 'react';
import { TASelect } from '../../ta-select';
import constants from '../constants';
import keywordsList from '../../../constants/keywords';
import skillsList from '../../../constants/skills';
import { TAInput } from '../../widgets';

const { Option } = Select;

export const CandidateToJobForm = React.forwardRef<any, any>(({ onSubmit }, ref) => {
	const [form] = useForm();
	const onFinish = values => {
		form.resetFields();
		onSubmit(values);
	};
	return (
		<Form ref={ref} onFinish={onFinish} name="matchJob" layout="vertical" className="ta-form">
			<Form.Item name="title" label="Title" rules={[{ required: true, message: 'Please add target job title' }]}>
				<TAInput placeholder="Target job's title" type="text" />
			</Form.Item>

			<Form.Item
				name="careerLevel"
				label="Career Level"
				rules={[{ required: true, message: 'Please choose candidate career level' }]}
			>
				<TASelect placeholder="Target job's career level">
					{Object.values(constants.CareerLevels).map(c => (
						<Option value={c} key={c}>
							{c}
						</Option>
					))}
				</TASelect>
			</Form.Item>

			<Form.Item
				name="skills"
				label="Skills"
				rules={[{ required: true, message: 'Please add candidate Skills' }]}
			>
				<TASelect mode="tags" placeholder="Add candidate skills">
					{Object.values(skillsList).map(skill => (
						<Option value={skill} key={skill}>
							{skill}
						</Option>
					))}
				</TASelect>
			</Form.Item>

			<Form.Item
				name="experience"
				label="Experience (in years)"
				rules={[{ required: true, message: 'Please add candidate experience' }]}
			>
				<TAInput type="number" placeholder="Add candidate experience, 0 for fresh, -1 for student" min={-1} />
			</Form.Item>

			<Form.Item name="minimumSalary" label="Expected Salary">
				<TAInput type="number" placeholder="Add candidate expected salary (in EGP)" min={1} />
			</Form.Item>

			<Form.Item name="keywords" label="Keywords">
				<TASelect mode="tags" placeholder="Add Keywords, may enhance matching">
					{Object.values(keywordsList).map(keyword => (
						<Option value={keyword} key={keyword}>
							{keyword}
						</Option>
					))}
				</TASelect>
			</Form.Item>
		</Form>
	);
});
